import { createInstance as api } from './index'
let URL = JSON.parse(localStorage.getItem('_system'))?.api ?? process.env.VUE_APP_API_HOST
export default {
    getDealerItems(params) {
        return api(URL).post('/items/getDealerItems', params)
    },
    login(params) {
        return api(URL).post('/credentials/login', params)
    },
    user_logged() {
        return api(URL).get('/credentials/user')
    },
    user_system_logged() {
        return api(URL).get('/credentials/user')
    },
    authentication() {
        return api(URL).get('credentials/authenticated')
    },
    SystemAuthentication() {
        return api(URL).get('credentials/authenticated')
    },
    getSystem() {
        return api(URL).post('credentials/dealer-systems')
    },
    dealerLogin(params) {
        return api(URL).get('credentials/dealer-login', { params })
    },
    logout() {
        return api(URL).post('credentials/logout')
    },
    getitemtypes(params) {
        return api(URL).get('dropdown/item-types', { params });
    },
    getitemcategories() {
        return api(URL).get('dropdown/item-categories');
    },
    exportitemmastertoexcel(params) {
        return api(URL).post('reports/exportItemMasterToExcel', params);
    },
    getBundledItems(params) {
        return api(URL).get(`items/getBundledItems/${params}`);
    },
    getgentradecustomers(params) {
        return api(URL).get(`dropdown/getGenTradeCustomers`, { params });
    },
    getBundles(params) {
        return api(URL).get('/dropdown/getBundles', { params });
    },
    getitemsmodelid(params) {
        return api(URL).get(`items/items/${params}`);
    },
    showcustomers(id) {
        return api(URL).get(`masterdata/customers/${id}`);
    },
     getcustomerpromoinfo(params){
        return api(URL).get(`promos/getCustomerPromoInfo/${params.customer_id}`,{params});
    },
     getItemEditInfoshared(params){
        return api(URL).post(`items/getItemEditInfo/${params.model_id}`,params);
    },
     getitems(params) {
        return api(URL).get('dropdown/getItems',{params});
    },
    getitemsbymodel(params){
        return api(URL).post('masterdata/items/details',params);
    },
    getDTItems(params) {
         const url = params.path;
        const method = params.method.toLowerCase();
        const config = ['get'].includes(method)
            ? { params }
            : params;

        return api(URL)[method](url, config);
    },
}

